import React from 'react'
import { Box, Typography, useMediaQuery, Theme } from '@mui/material'
const Breadcrumbs = ({
  ids,
  onBreadcrumbClick,
  singleLevelSSCC,
}: {
  ids: string[]
  onBreadcrumbClick: (index: number, id: string) => void
  singleLevelSSCC: boolean
}) => {
  const isSmallScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))
  return (
    <Box
      display={isSmallScreen ? 'block' : 'flex'}
      flexWrap="wrap"
      alignItems="center"
      marginTop="24px"
      marginBottom="20px"
      data-testid="breadcrumbs-container"
    >
      {ids.map((id, index) => (
        <React.Fragment key={id}>
          <Typography
            variant="body2"
            component="span"
            fontFamily="Sanomat-Medium-Web"
            color={
              singleLevelSSCC ? 'primary.dark' : index < ids.length - 1 ? 'primary.dark' : 'inherit'
            }
            onClick={() => index < ids.length - 1 && onBreadcrumbClick(index, id)}
            style={{
              cursor: index < ids.length - 1 ? 'pointer' : 'default',
              textDecoration: index < ids.length - 1 ? 'underline' : 'none',
              // color: index < ids.length - 1 ? '' : 'inherit',
              // fontSize: index === 0 ? (isSmallScreen ? '1.6rem' : '2rem') : '1.6rem',
              fontSize:
                index === 0
                  ? isSmallScreen
                    ? '1.4rem'
                    : '2.6rem'
                  : isSmallScreen
                    ? '1.2rem'
                    : '1.55rem',
              display: isSmallScreen ? 'block' : 'inline',
              marginBottom: isSmallScreen ? '8px' : '0',
              textTransform: 'uppercase',
            }}
          >
            {id}
          </Typography>
          {index < ids.length - 1 && !isSmallScreen && (
            <span color="primary.dark" style={{ margin: '0 8px', paddingTop: '8px' }}>
              {/* Arrow lagbe */}
              <svg
                data-name="right chevron icon"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                data-testid="chevron-icon"
              >
                <path d="M0 0h24v24H0z" style={{ fill: 'none' }} />
                <path
                  d="m324.6-714-4.6-4.6 1.4-1.4 6 6-6 6-1.4-1.4z"
                  transform="translate(-312 726)"
                  style={{ fill: '#145a4b' }}
                />
              </svg>
            </span>
          )}
        </React.Fragment>
      ))}
    </Box>
  )
}

export default Breadcrumbs
